import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/apps/adsmanager-ewo/layouts/default.vue").then(m => m.default || m))
}